import { useState, useEffect, useRef } from 'react';
import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Header } from '../../common/Header/Header.jsx';
import { SelectPerPage } from '../../common/Forms/Input/Input';
import {
  InboxTable
} from '../../common/Tables/Tables';
import {
  inboxTableHeader
} from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { salesNotificationService } from '../../../services/salesNotificationService';
import { useInboxCountStore } from '../../../stores/inboxCountStore';
import authService from '../../../services/authService';
import { useHistory } from 'react-router-dom';
import {
  FilterDatePicker,
} from '../../common/Forms/Input/Input';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';
import moment from 'moment';
import {
  filterParams,
} from '../../../assets/helpers/funciones';
import { salesRoles } from '../../../assets/helpers/roles';

const itemsPerpage = [10, 25, 50, 100, 500];






export const Inbox = () => {
  const tableRef = useRef(null);
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(
    moment().subtract(1, 'week').toDate()
  );
  const [dateTo, setDateTo] = useState(moment().toDate());

  const [seller, setSeller] = useState(
    [
      salesRoles?.SALES_HUNTER,
      salesRoles?.SALES_COUNTER,
      salesRoles?.SALES_FARMER,
      salesRoles?.SALES_KEY_ACCOUNTS,
    ].includes(authService?.getUserType())
      ? authService?.getUser()?._id
      : ''
  );
  const [minDate, setMinDate] = useState('');
  const [maxDate, setMaxDate] = useState('');

  const [membershipsDatatable, setMembershipsDatatable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: true,
    searchParam: '',

  });

  const setFirstPage = () => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    let eDate = new Date(moment(e)?.format('DD/MM/YYYY')).getTime();
    let to = new Date(moment(dateTo)?.format('DD/MM/YYYY')).getTime();

    if (eDate > to && dateTo) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    let eDate = new Date(moment(e)?.format('DD/MM/YYYY')).getTime();
    let from = new Date(moment(dateFrom)?.format('DD/MM/YYYY')).getTime();

    if (eDate < from && dateFrom) {
      notify('Ingrese una fecha en un rango valido ', 'info');
    } else {
      setFirstPage();
      setDateTo(e);
    }
  };

  const selectitemsPerpage = (event) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
        limit: parseInt(event.target.value),
      };
    });
  };

  const handlePageChange = (event, value) => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * membershipsDatatable?.limit,
      };
    });
  };


  const updateSalesNotification = (notificationId) => {

    const data = {
      hidden: true,
    }

    if (!isLoading) {
      setIsLoading(true);
      salesNotificationService
        .putSalesNotification(notificationId, data)
        .then((response) => {
          if ([200, 201].includes(response?.status)) {
            getRCVs();
            useInboxCountStore.getState().fetchInboxCount();
            setIsLoading(false);
          } else {
            setIsLoading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  };

  const checkReadNotification = (notification) => {

    if (notification?.subtype === "Comprobante cargado" && !notification?.readed) {

      const data = {
        readed: true,
      }

      if (!isLoading) {
        setIsLoading(true);
        salesNotificationService
          .putSalesNotification(notification?._id, data)
          .then((response) => {
            if ([200, 201].includes(response?.status)) {
              getRCVs();
              useInboxCountStore.getState().fetchInboxCount();
              setIsLoading(false);
            } else {
              setIsLoading(false);
              notify(`${response.message}`, 'error');
            }
          })
          .catch(() => { });
      }
    }
    history.push(`/afiliations/edit-order/${notification?.membership}`);
  };

  const showAllNotifications = () => {
    const data = {
      dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
      dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
    }

    if (!isLoading) {
      setIsLoading(true);
      salesNotificationService
        .showAllNotifications(data)
        .then((response) => {
          if (response.status === 200) {
            getRCVs();
            useInboxCountStore.getState().fetchInboxCount();
            setIsLoading(false);
          }
        })
        .catch(() => {
          setIsLoading(false);
        });
    };
  }



  const preloadDates = () => {


    let from = new Date("2026-01-02");
    // from = from.setDate(from.getDate() - 7);
    from = new Date(from);
    setDateFrom(from);
    setDateTo(new Date());

    const urlParams = new URLSearchParams(window.location.search);
    const fromUrl = urlParams.get('from');
    const to = urlParams.get('to');
    const sellerParam = urlParams.get('seller');

    if (fromUrl) {
      const fromDate = moment(fromUrl).startOf('month').toDate();
      if (fromDate) {
        setDateFrom(fromDate);
      }
    }
    if (to) {
      const toDate = moment(to).endOf('month').toDate();
      if (toDate) {
        setDateTo(toDate);
      }
    }

    if (sellerParam) {
      setSeller(sellerParam);
    } else {
      setSeller('');
    }
    getData();
  };


  useEffect(() => {
    preloadDates();
  }, []);

  useEffect(() => {
    getData();
  }, [
    membershipsDatatable?.page,
    membershipsDatatable?.offset,
    membershipsDatatable?.type,
    membershipsDatatable?.limit,
    seller,
    dateFrom,
    dateTo,
    seller,
  ]);



  const getData = () => {
    getRCVs();
  };

  const getRCVs = () => {
    if (dateFrom && dateTo) {
      setMembershipsDatatable((prevState) => {
        return {
          ...prevState,
          isLoading: true,
        };
      });

      if (!dateFrom || !dateTo) {
        return null;
      }

      let params = {
        dateFrom: dateFrom ? moment(dateFrom).format('MM-DD-YYYY') : '',
        dateTo: dateTo ? moment(dateTo).format('MM-DD-YYYY') : '',
        limit: membershipsDatatable?.limit,
        // offset: membershipsDatatable?.offset,
        page: membershipsDatatable?.page,

      };

      salesNotificationService
        .getSalesNotifications(filterParams(params))
        .then((response) => {
          if (response.status === 200) {
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.data,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            notify(`${response.message}` || 'error', 'error');
            setMembershipsDatatable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
      return true;
    }
  };



  return (
    <>
      <LoadSpinner show={membershipsDatatable?.isLoading || isLoading} />
      <Header />

      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            Inbox: {membershipsDatatable?.count}
          </h1>

        </div>
        <div className="breadcrumb-container">
          <div></div>
          <div className="exportables-buttons-container">
            <div style={{ width: '100%' }} className="row">
              <>
                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Desde'}
                  type={'date'}
                  name={'dateFrom'}
                  placeholder={''}
                  onChange={handleSinceDateChange}
                  value={dateFrom}
                  disabled={membershipsDatatable?.isLoading}
                  minDate={minDate}
                  maxDate={maxDate}
                />

                <FilterDatePicker
                  bootstrap={'col-12 col-md-2'}
                  label={'Hasta'}
                  type={'date'}
                  name={'dateTo'}
                  placeholder={''}
                  onChange={handleUntilDateChange}
                  value={dateTo}
                  disabled={membershipsDatatable?.isLoading}
                  maxDate={maxDate}
                />
              </>


              <div className="col-12 col-md-3" style={{ marginTop: '12px' }}>
                <SelectPerPage
                  label={'Registros por página'}
                  options={itemsPerpage}
                  value={membershipsDatatable?.limit}
                  onChange={selectitemsPerpage}
                />
              </div>
            </div>
            <ActionButton
              label={'Mostrar Todo'}
              width={'150px'}
              action={showAllNotifications}
            />
          </div>
        </div>
        <InboxTable
          header={inboxTableHeader}
          data={membershipsDatatable}
          handlePageChange={handlePageChange}
          updateSalesNotification={updateSalesNotification}
          checkReadNotification={checkReadNotification}
          tableRef={tableRef}
        />
      </div>
    </>
  );
};
